import { styled } from "@mui/material/styles";
import { Box, Paper } from "@mui/material";

export const AuthContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  backgroundColor: "#f7f8fc",
  paddingTop: "0px", // Default for desktop
  transform: "translateY(-50px)", // Shift everything up by 50px for better visual centering
});

export const Logo = styled("img")(({ theme }) => ({
  width: 150,
  marginBottom: 24,
  height: 'auto',
  maxWidth: '100%',
  // SVG-optimized rendering
  imageRendering: 'auto', // Let browser handle SVG rendering optimally
  [theme.breakpoints.down('md')]: {
    width: 120, // Slightly smaller on mobile for better proportion
  },
}));

export const AuthBox = styled(Paper)(({ theme }) => ({
  padding: 24,
  width: "100%",
  maxWidth: 400,
  border: "1px solid #e0e0e0",
  borderRadius: 4,
  boxShadow: "none",
  backgroundColor: "#fff",
  [theme.breakpoints.down('md')]: {
    margin: '0 24px', // Add 24px margins on left and right for mobile
    width: 'calc(100% - 48px)', // Adjust width to account for margins
  },
}));

export const FormContainer = styled(Box)({
  width: "100%",
  marginTop: 2,
});

export const LinkContainer = styled(Box)({
  textAlign: "center",
  marginTop: 16,
  "& a": {
    color: "#2196f3",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});
